export default __webpack_public_path__ + "static/media/user_pete.eb47ad6d.png";